import React from 'react';
import BaseProps from '../../../types/BaseProps';
import {ObjectContext} from '../context/ObjectContext';
import Loader from '../../loader/Loader';
import AlertError from '../../../common/alert/AlertError';
import {ObjectDetails} from "../../../types/Object";
import ObjectPropertiesView from "./ObjectPropertiesView";
import AlertWarning from '../../../common/alert/AlertWarning';

import "./ObjectView.scss";

export type ObjectViewProps = BaseProps & {
  renderTitle?: boolean
};

/**
 * Component for visualizing details of an object.
 */
export default class ObjectView extends React.Component<ObjectViewProps> {

  static contextType = ObjectContext;

  static defaultProps = {
    renderTitle: true
  };

  render() {
    const {loading, details, errors} = this.context;

    if (loading) {
      return viewWrapper(<ObjectLoader/>);
    } else if (details) {
      return viewWrapper(
        <>
          {this.props.renderTitle ? <ObjectTitle details={details}/> : null}
          {errors.length > 0 ? <ObjectErrors errors={errors} asWarnings={true}/> : null}
          <ObjectPropertiesView className="box-shadow" propertiesData={details.properties}/>
        </>
      );
    } else if (errors.length > 0) {
      return viewWrapper(<ObjectErrors errors={errors}/>);
    }

    return viewWrapper(null);
  }
}

function viewWrapper(children: any) {
  return (
    <div className="ObjectView">
      {children}
    </div>
  );
}

function ObjectLoader() {
  return (
    <div className="p-3 text-center">
      <Loader className="ObjectLoader" size="lg" block={true}/>
      <div>Loading object details</div>
    </div>
  );
}

export function ObjectTitle(props: { details: ObjectDetails }) {
  const title = props.details.propertiesMap['name']?.value || props.details.id;
  return <h2 className="ObjectTitle">{title}</h2>;
}

function ObjectErrors(props: { errors: Array<string>, asWarnings?: boolean }) {
  const errorMessages = props.errors.map((error: any) => {
    if (typeof error === "string" || error instanceof String) {
      return error;
    }
    if (error.message) {
      return error.message;
    }
    return JSON.stringify(error);
  }).map((error, index) => <p key={index}>{error}</p>);
  if (props.asWarnings) {
    return <AlertWarning className="ObjectWarnings">{errorMessages}</AlertWarning>
  }
  return <AlertError className="ObjectErrors">{errorMessages}</AlertError>;
}
